import { useEffect } from "react";
import { Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { useLoanVendorStore } from "../../hooks/userLoanVendorStore";
import { StandardDialog } from "@roc/ui";
import { Button } from "@roc/ui";
import { LoanCard } from "../card/loanCard";
import { SearchBar } from "./loanSearchBar";

interface LoanVendorModalProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: "1400px",
  },
  paper: {
    boxShadow: "none !important",
    border: "1px solid #cdcdcd",
    padding: "0px",
    borderRadius: "0 !important",
  },
  button: {
    marginRight: "8px",
  },
}));

export const LoanVendorsModal = observer(
  ({ open, onClose }: LoanVendorModalProps) => {
    const classes = useStyles();
    const { loanVendorStore } = useLoanVendorStore();

    useEffect(() => {
      loanVendorStore.getVendors();
      console.log(loanVendorStore.servicingVendors);
    }, []);

    useEffect(() => { }, [loanVendorStore.loan]);

    const onSave = () => {
      loanVendorStore.saveLoanVendor();
      onClose();
    };

    const getContent = () => {
      return (
        <>
          <Grid item xs={12} md={6}>
            <Box mb={2} width="50%">
              <SearchBar store={loanVendorStore} />
            </Box>
            {loanVendorStore.loan && (
              <LoanCard
                loan={loanVendorStore.loan}
                title={`Loan Information`}
              />
            )}
          </Grid>
        </>
      );
    };

    return (
      <StandardDialog
        open={open}
        title={"Assign New Loan"}
        maxWidth="md"
        handleClose={() => {
          onClose();
        }}
        dialogContent={getContent()}
        dialogActions={
          <>
            <Box mr={2}>
              <Button
                className={classes.button}
                variant="outlined"
                color="primary"
                onClick={() => {
                  onClose();
                  loanVendorStore.clearLoanVendor();
                }}
                testId="cancel"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => onSave()}
                testId="save"
                disabled={!loanVendorStore.loan}
              >
                Save
              </Button>
            </Box>
          </>
        }
      />
    );
  }
);
